export const sliderGalleryV1 = {
  elements: Array.from(
    document.querySelectorAll(".slider-gallery-v1 .swiper-container")
  ),
  details: (el) => {
    console.log();
    return {
      // Optional parameters
      // cssMode: true,
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 10,
      speed: 800,
      threshold: 10,
      centeredSlides: false,
      // centerInsufficientSlides: true,
      // initialSlide: Math.round(el.querySelectorAll("img").length / 2) - 1 || 0, // Imposta la slide iniziale
      // loopedSlides: 2, // Aumenta il numero di slide duplicate
      longSwipesRatio: 2,
      resistance: false,

      // Disable preloading of all images
      // preloadImages: true,
      // Enable lazy loading
      lazy: false,

      // If we need pagination
      pagination: {
        el: el.querySelector(".swiper-pagination"),
      },
      // Navigation arrows
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      // breakpoints: {
      //   1023: {
      //     slidesPerView: 1,
      //     spaceBetween: 20,
      //   },
      //   640: {
      //     slidesPerView: 1,
      //     spaceBetween: 20,
      //   },
      // },
      // on: {
      //   init: function () {
      //     setTimeout(() => {
      //       this.slideTo(Math.round(this.slides.length / 2) - 1 || 0, 0, false);
      //     }, 100);
      //   },
      // },
    };
  },
};
